import {notification} from "antd";
import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import PageTitle from "../../components/PageTitle";
import {getCharacterDetail} from "../../helpers/api/character";
import CharacterOutfitTable from "./CharacterOutfitTable";
import CharacterSoundTable from "./CharacterSoundTable";

const CharacterDetail = () => {

    const {characterId} = useParams();

    const [character, setCharacter] = useState<any>(null);

    const [api, contextHolder] = notification.useNotification();

    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    useEffect(() => {
        if (!characterId) {
            return;
        }
        getCharacterDetailById();
    }, [characterId]);

    const getCharacterDetailById = async () => {
        try {
            const res = await getCharacterDetail(characterId as string);
            setCharacter(res.data);
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
    }

    return (
        character && (<>
            {contextHolder}

            <PageTitle
                breadCrumbItems={[
                    {label: "Character", path: "/characters", active: false},
                    {label: "Character detail", path: "/characters/" + characterId, active: true},
                ]}
                title={<span><span className="text-danger">{character.name}</span></span>}
            />

            <Row>
                <Col>
                    <CharacterOutfitTable character={character}/>
                    <CharacterSoundTable character={character}/>
                </Col>
            </Row>
        </>)
    );
};

export default CharacterDetail;
